module.exports = __webpack_public_path__ + "static/media/samplefile_emp.33ff2fd5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/sample/samplefile_emp.csv
// module id = 1449
// module chunks = 1